import { useSuspenseQuery } from '@tanstack/react-query';

import { getAppShellDataQueryOptions } from '~/server/app/app-shell-data-query.ts';

export enum Theme {
	DARK = 'dark',
	LIGHT = 'light',
	SYSTEM = 'system',
}

export const themes: Array<Theme> = Object.values(Theme);

export function isTheme(value: unknown): value is Theme {
	return typeof value === 'string' && themes.includes(value as Theme);
}

export async function saveThemePreference(theme: Theme): Promise<void> {
	const formData = new FormData();
	formData.set('theme', theme);

	await fetch('/action/set-theme', {
		body: formData,
		method: 'POST',
	});
}

export function useRequestInfo() {
	const { data } = useSuspenseQuery(getAppShellDataQueryOptions());

	return data.requestInfo;
}

export function useTheme() {
	const requestInfo = useRequestInfo();

	return requestInfo.userPrefs.theme ?? requestInfo.hints.theme;
}

export function useUserLocale() {
	const requestInfo = useRequestInfo();

	return requestInfo.hints.locale;
}
